module.exports = __webpack_public_path__ + "static/media/business-lunch-food-court-3.65e2dea2.jpg";